// import css from "./popUp.module.css";

// export default function MainPop() {
//   return (
//     <div className={css.mainPopWrap}>
//       <p className={css.mainPopP}>
//         Пташка Час майстрів створена з першоелемента – жовтого квадрата, який
//         походить від ідеї Малевича. З нього все починається. Якщо його обернути
//         буде коло, протягнути – буде лінія. Так створюється набір
//         першоелементів, а з них будується весь Всесвіт. Жовтий колір несе світло
//         і свято. Птаха оспівує прекрасний світ. Наша птаха злітає зліва направо
//         – це символ еволюції, якій ми служимо.
//       </p>
//     </div>
//   );
// }
// src/components/MainPop.jsx
import React from "react";
import css from "./popUp.module.css";
import { db } from "../../firebase"; // скоригуй шлях під свій
import { doc, onSnapshot } from "firebase/firestore";

const DOC_ID = "ptashka_chas_maistriv"; // колекція: popups / документ: ptashka_chas_maistriv

export default function MainPop() {
  const [html, setHtml] = React.useState("");
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    const unsub = onSnapshot(doc(db, "popups", DOC_ID), (snap) => {
      setLoading(false);
      setHtml(snap.exists() ? snap.data()?.contentHtml || "" : "");
    });
    return () => unsub();
  }, []);

  return (
    <div className={css.mainPopWrap}>
      <div
        className={`${css.mainPopP}`}
        dangerouslySetInnerHTML={{ __html: loading ? "…" : html }}
      />
    </div>
  );
}
